import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Service for calling Firebase Cloud Functions related to PDF text extraction
 */
const functions = getFunctions();

/**
 * Manually trigger PDF text extraction for a specific journal entry
 * @param {string} entryId - The ID of the journal entry
 * @returns {Promise<object>} Result of the extraction
 */
export const extractPdfTextManual = async (entryId) => {
  try {
    const extractFunction = httpsCallable(functions, 'extractPdfTextManual');
    const result = await extractFunction({ entryId });
    return result.data;
  } catch (error) {
    console.error('Error calling extractPdfTextManual:', error);
    throw error;
  }
};

/**
 * Extract text from all existing PDF entries (migration function)
 * Use with caution - processes all PDFs
 * @returns {Promise<object>} Summary of the extraction process
 */
export const extractAllPdfTexts = async () => {
  try {
    const extractFunction = httpsCallable(functions, 'extractAllPdfTexts');
    const result = await extractFunction();
    return result.data;
  } catch (error) {
    console.error('Error calling extractAllPdfTexts:', error);
    throw error;
  }
};
